var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { connect } from 'react-redux';
import Immutable from 'immutable';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { bindActionCreators } from 'redux';

import { Translate } from "../../I18N";
import SidePanel from "../../Layout/SidePanel";
import { Icon } from "../../UI";
import { LocalForm, Control } from 'react-redux-form';
import { closeImportPanel, importData } from "../actions/uploadsActions";
import ImportProgress from "./ImportProgress";

class ImportPanel extends Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.close = this.close.bind(this);
  }

  handleSubmit(values) {
    this.props.importData(values.file, values.template);
  }

  close() {
    this.props.closeImportPanel();
  }

  renderForm() {var _templates$find;
    const { templates } = this.props;
    const template = (_templates$find = templates.find((templ) => templ.get('default'))) === null || _templates$find === void 0 ? void 0 : _templates$find.get('_id');
    return /*#__PURE__*/(
      _jsx("div", {}, void 0, /*#__PURE__*/
      _jsx("div", { className: "alert alert-info" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "info-circle", size: "2x" }), /*#__PURE__*/
      _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Upload a ZIP or CSV file."), "\xA0", /*#__PURE__*/
      _jsx("a", {
        rel: "noopener noreferrer",
        href: "https://github.com/huridocs/uwazi/wiki/Import-CSV",
        target: "_blank" }, void 0, /*#__PURE__*/

      _jsx(Translate, {}, void 0, "Import instructions")
      )
      )
      ), /*#__PURE__*/
      _jsx(LocalForm, { onSubmit: this.handleSubmit, id: "import", initialState: { template } }, void 0, /*#__PURE__*/
      _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "search__filter" }, void 0, /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx("label", { htmlFor: "file" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "File")
      )
      ), /*#__PURE__*/
      _jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
      _jsx(Control.file, { id: "file", model: ".file", accept: ".zip,.csv" })
      )
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
      _jsx("ul", { className: "search__filter" }, void 0, /*#__PURE__*/
      _jsx("li", {}, void 0, /*#__PURE__*/
      _jsx("label", { htmlFor: "template" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Template")
      )
      ), /*#__PURE__*/
      _jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
      _jsx(Control.select, { id: "template", model: ".template" }, void 0,
      templates.map((t) => /*#__PURE__*/
      _jsx("option", { value: t.get('_id') }, t.get('_id'),
      t.get('name')
      )
      )
      )
      )
      )
      ), /*#__PURE__*/
      _jsx("div", { className: "form-group" })
      ), /*#__PURE__*/
      _jsx("div", { className: "sidepanel-footer" }, void 0, /*#__PURE__*/
      _jsx("button", { form: "import", type: "submit", className: "btn btn-primary", id: "import-csv" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "upload" }), /*#__PURE__*/
      _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Import")
      )
      )
      )
      ));

  }

  renderUploadProgress() {
    const { uploadProgress } = this.props;
    return /*#__PURE__*/(
      _jsx("div", { className: "alert alert-info" }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "info-circle", size: "2x" }), /*#__PURE__*/
      _jsx("div", { className: "force-ltr" }, void 0, /*#__PURE__*/
      _jsx(Translate, {}, void 0, "Uploading file"), " ", uploadProgress, "%"
      )
      ));

  }

  renderContents() {
    const { uploadProgress, importStart, importProgress } = this.props;
    if (uploadProgress) {
      return this.renderUploadProgress();
    }

    if (importStart || importProgress) {
      return /*#__PURE__*/_jsx(ImportProgress, {});
    }
    return this.renderForm();
  }

  render() {
    const { open } = this.props;
    return /*#__PURE__*/(
      _jsx(SidePanel, { open: open, className: "metadata-sidepanel" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "sidepanel-header" }, void 0, /*#__PURE__*/
      _jsx("button", { type: "button", className: "closeSidepanel close-modal", onClick: this.close }, void 0, /*#__PURE__*/
      _jsx(Icon, { icon: "times" })
      )
      ),
      this.renderContents()
      ));

  }
}

ImportPanel.defaultProps = {
  open: false,
  uploadProgress: 0,
  importStart: false,
  importProgress: 0
};











const mapStateToProps = (state) => ({
  open: state.importEntities.showImportPanel,
  templates: state.templates,
  uploadProgress: state.importEntities.importUploadProgress,
  importStart: state.importEntities.importStart,
  importProgress: state.importEntities.importProgress
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ closeImportPanel, importData }, dispatch);
}

export { ImportPanel, mapDispatchToProps };

export default connect(mapStateToProps, mapDispatchToProps)(ImportPanel);